<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="v" class="page" epub:type="pagebreak" id="pv" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocf"><a class="xref" href="#/umaDOLAN0007#ch01">Hit or Miss</a></p>
<p class="toc"><a class="xref" href="#/umaDOLAN0008#ch02">A Perfect Day at Riis Park</a></p>
<p class="toc"><span class="xref" href="#/umaDOLAN0009#ch03" title="Link target outside of Sample">Fortunetellers in Williamsburg</span></p>
<p class="toc"><span class="xref" href="#/umaDOLAN0010#ch04" title="Link target outside of Sample">Lightning Ridge</span></p>
<p class="toc"><span class="xref" href="#/umaDOLAN0011#ch05" title="Link target outside of Sample">Those Delusions of Grandeur</span></p>
<p class="toc"><span class="xref" href="#/umaDOLAN0012#ch06" title="Link target outside of Sample">Quarters</span></p>
<p class="toc"><span class="xref" href="#/umaDOLAN0013#ch07" title="Link target outside of Sample">People from Chicago</span></p>
<p class="toc"><span class="xref" href="#/umaDOLAN0014#ch08" title="Link target outside of Sample">Lies and Funerals, Complexications</span></p>
<p class="toc"><span class="xref" href="#/umaDOLAN0015#ch09" title="Link target outside of Sample">The Boy</span></p>
<p class="toc"><span class="xref" href="#/umaDOLAN0016#ch10" title="Link target outside of Sample">Rancho Village</span></p>
<p class="toc"><span class="xref" href="#/umaDOLAN0017#ch11" title="Link target outside of Sample">Safe Places</span></p>
<p class="toc"><span class="xref" href="#/umaDOLAN0018#ch12" title="Link target outside of Sample">Falling Off the George Washington Bridge</span></p>
<p class="tocbmf"><span class="xref" href="#/umaDOLAN0019#acknow" title="Link target outside of Sample">Acknowledgments</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// umaDOLAN0005.vue?d0194f0a